var _rect, _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatarBb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.574219,
    y: 0.90625,
    width: 3.15003,
    height: 24.1893,
    fill: "#1D1E2C"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.4813,
    cy: 16.1032,
    rx: 8.9461,
    ry: 8.99184,
    fill: "#1D1E2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarBb);
export default __webpack_public_path__ + "static/media/avatar_bb.6f8cdde7c16fb1c24e3070335a47024f.svg";
export { ForwardRef as ReactComponent };